import React from 'react'

function EmailSettings() {
  return (
    <div>EmailSettings</div>
  )
}

export default EmailSettings